import React from 'react'
import SportsLayoutComp from '../../../components/sports/sports layout/SportsLayoutComp'

const CrossCountry = () => {
  return (
    <SportsLayoutComp name={'Cross Country'}/>
  )
}

export default CrossCountry